import {
    apiRequest,
    pangkatP3KDetail,
    pangkatP3KUpdate
} from "../../../../../services/adapters/master/pangkatP3KService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pangkatP3KDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", pangkatP3KUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository